import { api, apiPublic } from './client';
import type { ContactSettings, EditableContactSettings } from '../features/contactSettings/types';
export type { ContactSettings, EditableContactSettings } from '../features/contactSettings/types';

export async function getPublicContactSettings(): Promise<ContactSettings> {
  return apiPublic.get<ContactSettings>('/api/contact-settings');
}

export async function updateContactSettings(
  data: EditableContactSettings
): Promise<ContactSettings> {
  return api.patch<ContactSettings>('/api/contact-settings', data);
}
